<template>
	<div class="page-width">
		<datatable title="Recruiter Fees" :response="data" :fields="fields" :show_edit="false" :is_createable="false" :show_operations="false">
		</datatable>
	</div>
</template>
<script>
	import { mapMutations } from 'vuex'
	import Datatable from '@/components/Datatable'
	export default {
		name: 'recruiter-fees',
		data(){
			return {
				fields: [
				    {
				      name: 'Recruiter',
				      value: 'recruiter_name'
				    },
				    {
				      name: 'Fee',
				      value: 'fee'
				    },
				],
				data: [],
			}
		},
		created(){
			this.$network_utils.getRecruiterFees().then(response => {
				this.data = response
			})
		},
		methods: {
			...mapMutations('modals', ['createModal'])
		},
		components: {
			Datatable
		}
	}
</script>